import React from 'react';
// noinspection ES6CheckImport
import {Route, Switch} from 'react-router-dom';
import OrdersList from './OrdersList';
import OrdersDetail from './OrdersDetail';

function Orders() {
  return (
    <Switch>
      <Route exact path={'/mi-cuenta/mis-pedidos'} component={OrdersList} />
      <Route
        exact
        path={'/mi-cuenta/mis-pedidos/:id'}
        component={OrdersDetail}
      />
    </Switch>
  );
}

export default Orders;
